import ActionTypes from '../actions/types';
import StatusTypes from '../store/types';

function userReducer(state = {}, action) {
  console.log('userReducer() action: ', action);
  const { error, response } = action;

  switch (action.type) {
    case ActionTypes.REGISTER_REQUEST:
      return { status: StatusTypes.registerPending };
    case ActionTypes.REGISTER_SUCCESS:
      return { status: StatusTypes.registerSuccess, response };
    case ActionTypes.REGISTER_FAIL:
      return { status: StatusTypes.registerFail, error };
    case ActionTypes.LOGIN_REQUEST:
      return { status: StatusTypes.loginPending };
    case ActionTypes.LOGIN_SUCCESS:
      return { status: StatusTypes.loginSuccess, user: response };
    case ActionTypes.LOGIN_FAIL:
      return { status: StatusTypes.loginFail, error };
    case ActionTypes.LOGOUT_SUCCESS:
      return {};
    case ActionTypes.USER_UPDATE_REQUEST:
      return { ...state, status: StatusTypes.updateUserPending };
    case ActionTypes.USER_UPDATE_SUCCESS:
      return { status: StatusTypes.updateUserSuccess, user: response };
    case ActionTypes.USER_UPDATE_FAIL:
      return { ...state, status: StatusTypes.updateUserFail, error };
    case ActionTypes.USER_UPDATE_IMG_REQUEST:
      return { ...state, status: StatusTypes.uploadPicturePending };
    case ActionTypes.USER_UPDATE_IMG_SUCCESS:
      return { status: StatusTypes.uploadUserImgSuccess, user: response };
    case ActionTypes.USER_UPDATE_IMG_FAIL:
      return { ...state, status: StatusTypes.uploadUserImgFail, error };
    default:
      return state;
  }
}

export default userReducer;
